<template>
    <div
        v-if="value && numbers"
        class="w-100 lm-border pa-3"
        style="position: relative"
    >
        <div class="create-button" >
            <v-btn
                v-if="createAllowed"
                color  = "primary"
                @click = "onCreate"
                fab
                x-small
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </div>
        <v-row content="no-frame">
            <v-col class="no-frame">
                <slot name="pre"></slot>
            </v-col>
        </v-row>

        <draggable
            tag    = "ul"
            :list  = "numbers"
            class  = "list-group"
            handle = ".handle"
            @change="onChanged"
        >
            <transition-group type="transition" name="flip-list">
            <li
                class="list-group-item"
                v-for="(number, index) in numbers"
                :key="'number' +index"
            >
                <f-phone-number
                    v-model = "number.value"
                    class   = "w-100"
                    @delete = "onDelete(index)"
                    @input  = "onChanged"
                />
            </li>
            </transition-group>
        </draggable>
    </div>
</template>

<script>

import draggable from "vuedraggable";
import FPhoneNumber from "@/modules/msd/common/components/FPhoneNumber";

export default {
    name: "FPhoneNumbers",
    components: {
        FPhoneNumber,
        draggable
    },

    props: {
        value: {
            required: false,
            type    : Array
        }
    },

    data: () => ({
        maxNumbers: 6,
        numbers: [],
    }),

    mounted() {
        this.initialize();
    },

    watch: {
        value() {
            this.initialize();
        },
    },

    computed: {
        createAllowed () {
            return this.numbers.length < this.maxNumbers;
        }
    },

    methods: {
        initialize () {
            if (!this.value) {
                return;
            }

            this.init = true;
            this.numbers = [];
            const sorted = this.value.slice().sort ((l,r) => { return l.rank - r.rank; });

            sorted.forEach(e => {
                this.numbers.push({
                    value: e,
                })
            })
        },

        onCreate () {
            if (!this.createAllowed) {
                return;
            }

            this.numbers.push ({
                value: {
                    type: {
                        id  : 1,
                        name: "Festnetz",
                    },
                    number: "+49"
                }
            });

        },

        onDelete (index) {
            this.numbers.splice(index, 1)
            if (this.numbers.length === 0) {
                this.onCreate();
            }

            this.onChanged();
        },

        onChanged () {
            const value = [];
            let rank = 1;
            this.numbers.forEach (n => {
                const number = n.value;
                number.rank = rank;
                rank ++;
                value.push(number);
            })
            this.$emit("input", value);
        }
    }
}

</script>

<style scoped>

.create-button {
    position: absolute;
    left: 15px;
    bottom: -15px
}

.list-group {
    padding-left: 0!important;
}

.list-group-item {
    list-style: none;
    background-color: white;
    border-color: lightgray;
    border-width: 1px;
    border-style: solid;
    margin-bottom: 4px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    border-radius: 4px;
}


</style>